import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=4e0ec005&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e0ec005')) {
      api.createRecord('4e0ec005', component.options)
    } else {
      api.reload('4e0ec005', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=4e0ec005&", function () {
      api.rerender('4e0ec005', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8kD9KJrWUUtqS/JS/comp/stardisplay.vue"
export default component.exports